export default __webpack_public_path__ + "static/Vidrios_Aluminios_5-f19648a29f9bdb5623c776128d1bc3e2.png";